module.exports = __webpack_public_path__ + "img/arrow_left.2e1b03b3.svg";